export default function () {
  const widgetName = 'mainFeature';
  const widgetOpts = mainFeatureOpts;

  function removeHref(data) {
    $(`#${widgetName} .card-widget-item`).each(function (x, item) {
      if (data.items[x]?.URL === null) {
        $(item).removeAttr('href');
      }
    });
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      $(`#${widgetName} .buttonwrap`).remove();
      removeHref(data);
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
